import { useTranslation } from 'react-i18next'
import useFlowStore from '../../../components/chatflow/store'
import {
  CtxOverlay,
  CtxMenu,
  CtxItem,
  CtxKey,
  CtxSep,
} from '../../../components/chatflow/styles'

/**
 * EditorContextMenu — Canvas context menu UI.
 *
 * Reads position and target node directly from the Zustand store.
 * Receives action callbacks via props (no direct access to canvas state).
 */
interface EditorContextMenuProps {
  onAddNode: (type: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDuplicate: (node: any) => void;
  onDelete: (nodeId: string) => void;
}

export default function EditorContextMenu({ onAddNode, onDuplicate, onDelete }: EditorContextMenuProps) {
  const { t } = useTranslation()
  const contextMenu    = useFlowStore((s) => s.contextMenu)
  const setContextMenu = useFlowStore((s) => s.setContextMenu)

  if (!contextMenu) return null

  const { node } = contextMenu

  return (
    <>
      <CtxOverlay onClick={() => setContextMenu(null)} />
      <CtxMenu $x={contextMenu.x} $y={contextMenu.y}>
        {node ? (
          <>
            <CtxItem onClick={() => onDuplicate(node)}>
              {t('context_menu.duplicate')} <CtxKey>⌘D</CtxKey>
            </CtxItem>
            <CtxSep />
            <CtxItem $danger onClick={() => onDelete(node.id)}>
              {t('context_menu.delete')} <CtxKey>Del</CtxKey>
            </CtxItem>
          </>
        ) : (
          <>
            <CtxItem onClick={() => { onAddNode('step'); setContextMenu(null) }}>{t('context_menu.message')}</CtxItem>
          </>
        )}
      </CtxMenu>
    </>
  )
}
